import { Helmet } from "react-helmet";
import ComplaintsPolicy from "../components/SupportCenter/ComplaintsPolicy";
import PageBanner from "../components/Shared/PageBanner";

const ComplaintsPolicyPage = () => {
  return (
    <div className="pb-16">
      <Helmet>
        <link
          rel="canonical"
          href="https://www.nilewisect.com/complaints-policy"
        />
      </Helmet>
      <PageBanner title="Complaints Policy" />
      <ComplaintsPolicy />
    </div>
  );
};

export default ComplaintsPolicyPage;
